import React from 'react';
import { connect } from 'react-redux';
import { createWatchList, toggleConfirmPopupCreateWatchList } from '../reducer';
import Validation from './../../../helpers/Validation';
import { I18n, Translate } from 'react-redux-i18n';
import { REDUCER_NAME } from './../reducer';
import Toggle from './../../../common/Toggle';

const KEY_ENTER = 13;
const WL_LIMIT = 20;

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
    };

    this.nameRef = React.createRef();
  }

  clearInputName = () => {
    this.nameRef.current.value = '';
  };

  cancel = showHide => () => {
    this.clearInputName();
    showHide(false);
  };

  create = showHide => () => {
    const name = this.nameRef.current.value;
    const {
      createWatchList,
      toggleConfirmPopupCreateWatchList,
      listMyIndex,
      type,
    } = this.props;

    const validation = new Validation(name);
    let messages = validation
      .isEmpty()
      .startWithAlphabetOrNumber()
      .limitCharacter(50).messages;
    if (messages.length > 0) {
      toggleConfirmPopupCreateWatchList(true, 'message.invalid_name_title', [
        I18n.t('message.invalid_name_message'),
      ]);
    } else if (listMyIndex.length >= WL_LIMIT) {
      toggleConfirmPopupCreateWatchList(
        true,
        I18n.t('message.exceed_limit_title', { name: 'WatchList' }),
        [
          I18n.t('message.exceed_limit_create_message', {
            count: WL_LIMIT,
            name: 'watchList',
          }),
        ],
      );
    } else {
      createWatchList(validation.format(name), type);
    }
    this.cancel(showHide)();
  };

  onKeyDown = showHide => e => {
    switch (e.keyCode) {
      case KEY_ENTER:
        this.create(showHide)();
        break;
      default:
        break;
    }
  };

  renderAction = toggle => {
    return (
      <button
        className="btn btn-cus bg-b-color-3 dropdown-toggle"
        title={I18n.t('watchListSummary.createNewWatchlistIcon')}
        type="button"
        onClick={toggle}
        aria-haspopup="true"
      >
        <i className="icon-plus-s fs-11" />
      </button>
    );
  };

  renderPopup = (showHide, isShow) => {
    return (
      isShow && (
        <div
          className={`dropdown-menu drop-mecus drop-normal show`}
          aria-labelledby="dropdownMenuButton"
          style={{
            position: 'absolute',
            transform: 'translate3d(-110px, 20px, 0px)',
            top: 0,
            right: 0,
            willChange: 'transform',
          }}
        >
          <div className="p-10">
            <div className="form-group">
              <input
                type="text"
                className="form-control pr-20"
                placeholder={I18n.t('watchListSummary.nameYourWatchlist')}
                ref={this.nameRef}
                onKeyDown={this.onKeyDown(showHide)}
              />
              <button
                className="btn-cancel-search"
                type="button"
                onClick={this.clearInputName}
              >
                <i className="icon-cancel" />
              </button>
            </div>
            <div className="group-btn d-flex">
              <button
                type="button"
                className="btn btn-cus text-nomal text-uppercase bg-b-color-3"
                onClick={this.create(showHide)}
              >
                <Translate value={'common.CREATE'} />
              </button>
              <button
                type="button"
                className="btn btn-cus text-nomal text-uppercase bg-s-color-3 float-right"
                onClick={this.cancel(showHide)}
              >
                <Translate value={'common.CANCEL'} />
              </button>
            </div>
          </div>
        </div>
      )
    );
  };

  render() {
    return (
      <div className="item-btn">
        <div className={`dropdown`}>
          <Toggle
            canEscToClose={true}
            renderAction={this.renderAction}
            renderPopup={this.renderPopup}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    listMyIndex: state[REDUCER_NAME].listMyIndex,
  };
};

const mapDispatchToProps = {
  toggleConfirmPopupCreateWatchList,
  createWatchList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Create);
